/// <amd-module name="Artifacts/Root/routing/Tools" />
import { CenteredSpinner } from "Artifacts/Root/components/CenteredSpinner";
import { wrapWithBasePage } from "Artifacts/Root/containers/BasePage";
import * as React from "react";
import { WrappedComponent } from "VSS/Platform/Layout";

/**
 * lazyLoadComponent gets component from VSS components store and loads it asynchronously
 * @param componentType component type defined in contribution config for the component
 * @param fallback fallback component that is rendered until actual component are loaded and ready to be rendered
 * @returns React component
 *
 */
export function lazyLoadComponent(
  componentType: string,
  fallback: (() => JSX.Element) | undefined,
): React.ComponentType {
  return () => (
    <WrappedComponent
      wrappedType={componentType}
      dependencies={[componentType]}
      loadingComponent={fallback}
    />
  );
}

export function lazyLoadComponentWithDefaultLoader<T>(
  componentType: string,
): React.ComponentType<T> {
  return () => (
    <WrappedComponent
      wrappedType={componentType}
      dependencies={[componentType]}
      loadingComponent={() => <CenteredSpinner />}
    />
  );
}

export function asLazyContainerComponent<T>(
  contributionId: string,
  tabTitle?: string,
): React.ComponentType<T> {
  return wrapWithBasePage(lazyLoadComponentWithDefaultLoader(contributionId), tabTitle);
}
